module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/351.3eb0be0a.png";